import { render, staticRenderFns } from "./smsIcon.vue?vue&type=template&id=47fb3504&"
import script from "./smsIcon.vue?vue&type=script&lang=js&"
export * from "./smsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports